import { OnlineBanner } from "~/entities/bannerEntities";
import Client from "../baseClient";
import { getSubdomainFromRequest } from "~/helpers/requestHelpers";

export const BannerApi = {
  /**
   * Banners for this site and order type, already filtered by template, site,
   * order type and schedule.
   */
  getBanners: async (request: Request, siteId: string, orderTypeCode: string) =>
    await Client.get<OnlineBanner[]>(
      `org/${getSubdomainFromRequest(
        request,
      )}/sites/${siteId}/banners?orderTypeCode=${encodeURIComponent(
        orderTypeCode,
      )}`,
    ),
};
